import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import s from './H5.module.scss'

function H5({ className, children, bold, muted, inline, ...props }) {
  const classes = classnames(s.h5, className, {
    [s.bold]: bold,
    [s.muted]: muted,
    [s.inline]: inline
  })

  return (
    <div className={classes} role="heading" aria-level="5" {...props}>
      {children}
    </div>
  )
}

H5.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  bold: PropTypes.bool,
  muted: PropTypes.bool,
  inline: PropTypes.bool
}

H5.defaultProps = {
  className: null,
  children: null,
  bold: false,
  muted: false,
  inline: false
}

export default H5
